function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function ($) {
  var cartAjax = function cartAjax() {
    var products = $('.add-to-cart');
    var cartCount = $('#CartCount');
    var stickCartCount = $('#StickCartCount');

    products.each(function (index, element) {
      var id = $(element).find('[name="id"]').attr('value');
      var quantityInput = $(element).find('[name="quantity"]');

      var addButtonLegacy = $(element).find('.add-to-cart__btn--legacy');
      var addButton = $(element).find('.add-to-cart__btn-add');
      var removeButton = $(element).find('.add-to-cart__btn-remove');
      var buttonsWrapper = $(element).find('.add-to-cart__btn-wrapper');

      var throbber = $(element).find('.add-to-cart__throbber');
			var cartConfirmation = $(element).find('.add-to-cart__confirmation');

      // add to cart
      $.each([addButtonLegacy, addButton], function (index, element) {
        element.off();
        element.click(function (e) {
          e.preventDefault();

          var newCartCountValue = parseInt(cartCount.find('.quantity-number-wrapper').text()) + 1;
          var newQuantityValue = parseInt(quantityInput.attr('value')) + 1;
          throbber.show();
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: id
            },
            complete: function complete(data) {

              throbber.hide();

              // Is added out of stock item to cart
              var responseData = $(JSON.parse(data.responseText));
              if (responseData.prop('status') == 422) {
                noMoreItemsAlert.slideDown('fast');
                return;
              }

              // Change quantity in product item, between - and + buttons
              quantityInput.attr('value', newQuantityValue);

              // paste value to cartCout
              cartCount.find('.quantity-number-wrapper').text(newCartCountValue);
              if (stickCartCount) {
                stickCartCount.find('.stick-cart__quantity').text(newCartCountValue);
              }

              // show cartCount if new val = 1
              if (newCartCountValue == 1) {
                cartCount.removeClass('site-header__cart-count--hide');
                if (stickCartCount) {
                  stickCartCount.removeClass('stick-cart__cart-count--hide');
                }
              }

              // show buttons and hide legacy button if new val = 1
              if (newQuantityValue == 1) {
                buttonsWrapper.show();
                addButtonLegacy.hide();
              }
            }
          });
        });
      });

      // remove form cart
      removeButton.click(function (e) {
        e.preventDefault();
        var newCartCountValue = cartCount.find('.quantity-number-wrapper').text() == 0 ? 0 : parseInt(cartCount.find('.quantity-number-wrapper').text()) - 1;
        var newQuantityValue = quantityInput.attr('value') == 0 ? 0 : parseInt(quantityInput.attr('value')) - 1;

        throbber.show();
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: _defineProperty({}, id, newQuantityValue)
          },
          complete: function complete(data) {
            quantityInput.attr('value', newQuantityValue);
            throbber.hide();

            // paste value to cartCout
            cartCount.find('.quantity-number-wrapper').text(newCartCountValue);
            if (stickCartCount) {
              stickCartCount.find('.stick-cart__quantity').text(newCartCountValue);
            }

            // hide cartCount if new val = 1
            if (newCartCountValue == 0) {
              cartCount.addClass('site-header__cart-count--hide');
              if (stickCartCount) {
                stickCartCount.addClass('stick-cart__cart-count--hide');
              }
            }

            // hide buttons and hide legacy button if new val = 1
            if (newQuantityValue == 0) {
              buttonsWrapper.hide();
              addButtonLegacy.show();
            }
          }
        });
      });
    });
  };

  if ($('.template-collection').length !== null) {
    cartAjax();
  }
})(jQuery);
